import { Input } from './input';
import { ElementHelpers } from '../../helpers/element-helpers';

export class FileUpload extends Input {
	constructor(elem, form) {
		super(elem, form);
		this.holder = ElementHelpers.getParentByClass(elem, 'form-group');
		this.form = form;
		this.elem = elem;
		this.textElem = this.holder.querySelector('.file-upload__text');
		this.feedbackHolder = this.holder.querySelector('.form-group__feedback');
		this.defaultText = this.textElem.textContent;

		this.maxSize = this.elem.getAttribute('data-max-size');
		this.maxSizeExceededMessage = this.elem.getAttribute('data-max-size-exceeded-message');
		this.invalidExtensionMessage = this.elem.getAttribute('data-invalid-extension-message');

		this.addEventHandlers();
	}

	static getSelector() {
		return 'input[type="file"]';
	}

	addEventHandlers() {
		this.elem.addEventListener('change', () => {
			const arr = this.elem.value.split('\\');
			const fileName = arr[arr.length - 1];
			if (fileName) {
				this.textElem.textContent = fileName;
				if (this.validateFile(fileName)) {
					this.removeError();
				}
			} else {
				this.textElem.textContent = this.defaultText
			}
		});
	}

	validateFile(filename) {
		const allowedExtensions = this.elem.getAttribute('accept').split(',');
		const fileExt = `.${filename.split('.').pop().toLowerCase()}`;

		if (this.elem.files[0].size > this.maxSize) {
			this.setError(this.maxSizeExceededMessage);
			return false;
		}
		if (!allowedExtensions.find((ext) => ext === fileExt)) {
			this.setError(this.invalidExtensionMessage);
			return false;
		}

		return true;
	}
}

